import { useLayoutEffect } from "react";

export function useHeaderHeight() {
  useLayoutEffect(() => {
    const setHeaderHeight = () => {
      const isMobile = window.matchMedia("(max-width: 991px)").matches;

      const headerEl = !isMobile
        ? document.querySelector(
            "[data-testid] > .bg-white-100 > .sticky.top-0.z-50",
          )
        : document.querySelector(
            '.festival > .bg-white-100 > .max-lg\\:max-h-\\[52px\\].translate-y-0 [data-testid="header-headerContainer"]',
          );

      const headerHeight = (headerEl as HTMLElement | null)?.offsetHeight ?? 0;

      document.documentElement.style.setProperty(
        "--headerHeight",
        `${headerHeight}px`,
      );

      const activeStickyBar = document.querySelector<HTMLElement>(
        ".v_showStickyBar .v_stickyArticleNow",
      );

      const totalHeight = headerHeight + (activeStickyBar?.offsetHeight ?? 0);

      document.documentElement.style.setProperty(
        "--totalNewHeadHeight",
        `${totalHeight}px`,
      );
    };

    // Initial
    setHeaderHeight();

    window.addEventListener("resize", setHeaderHeight);
    window.addEventListener("scroll", setHeaderHeight);

    return () => {
      window.removeEventListener("resize", setHeaderHeight);
      window.removeEventListener("scroll", setHeaderHeight);
    };
  }, []);
}
